import Image, { StaticImageData } from "next/image";
import { ChangeEvent, CSSProperties, forwardRef, HTMLInputTypeAttribute, KeyboardEventHandler, LegacyRef, useRef } from "react";
import styles from "./input.module.scss";

interface InputProps {
    type?: HTMLInputTypeAttribute,
    label?: string;
    name?: string;
    value?: string;
    placeholder?: string;
    customStyle?: CSSProperties;
    helper?: string;
    required?: boolean;
    mode?: "error" | "disable";
    iconRight?: Icon,
    iconLeft?: Icon,
    autoComplete?: string,
    dir?: string,
    onBlur?: (event: ChangeEvent<HTMLInputElement>) => void;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    onKeyUp?: KeyboardEventHandler<HTMLInputElement>
}

interface Icon {
    src: StaticImageData;
    alt: string;
  }

export const Input = forwardRef(({ type = 'text', label, name, value, placeholder, customStyle, helper, required = false, mode, iconRight, iconLeft, onBlur, onChange, autoComplete, onKeyUp, dir}: InputProps, ref: LegacyRef<HTMLInputElement>) => {
    // const inputRef = useRef(null);

    // const handleChange = () => {
    //     onChange && onChange(inputRef.current.value);
    // };

    return (<>
        <div className={`${styles[mode] ?? ""} ${styles.wrapper}`} style={customStyle}>
            {label && <label>{label}</label>}
            <input
                type={type}
                placeholder={placeholder}
                value={value}
                ref={ref}
                name={name}
                required={required}
                autoComplete={autoComplete}
                dir={dir}
                onKeyUp={onKeyUp}
                // onChange={handleChange}
            />
            {iconRight && <img src={iconRight.src.src} alt={iconRight.alt} className={styles.right_icon}/>}
            {iconLeft && <img src={iconLeft.src.src} alt={iconLeft.alt} className={styles.left_icon}/>}
        </div>
        {helper && <p className={styles.helper}>{helper}</p>}
    </>
    );
})
